import axios from "axios";

// ─────────────────────────────────────────────────────────────
// 로그 수집 클라이언트 헬퍼 (Core Backend /api/core/log 로 전송)
//
// 원칙: 대부분의 로그는 각 백엔드에서 남긴다(신뢰 컨텍스트·우회 불가).
//       이 헬퍼는 "백엔드를 안 거치는 순수 클라 이벤트"(화면 접근 거부 등)용.
// 특성: fire-and-forget — 실패해도 본 기능을 절대 깨지 않는다(throw 안 함).
// ─────────────────────────────────────────────────────────────

const CLIENT_APP = "MAIN"; // 이 SPA 셸 기준

function detectPlatform() {
  const ua = (navigator && navigator.userAgent) || "";
  if (/Android/i.test(ua)) return "MOBILE_ANDROID";
  if (/iPhone|iPad|iPod/i.test(ua)) return "MOBILE_IOS";
  return "WEB";
}

function currentUser() {
  try {
    const vuex = JSON.parse(localStorage.getItem("vuex") || "{}");
    return vuex && vuex.loginStore && vuex.loginStore.userInfo
      ? vuex.loginStore.userInfo
      : null;
  } catch (e) {
    return null;
  }
}

/**
 * @param {string} eventType  예: "CORE_ACCESS_DENIED"
 * @param {object|null} eventData 예: { path: "/admin" }
 * @param {object} opts { level, clientApp, platform, appVersion, company }
 */
export function logEvent(eventType, eventData = null, opts = {}) {
  try {
    if (!eventType) return;
    const user = currentUser();
    axios
      .post("/api/core/log", {
        EventType: eventType,
        EventData: eventData,
        Level: opts.level || "INFO",
        UserId: opts.userId || (user && user.UserId) || null,
        Company: opts.company || (user && user.Company) || null,
        Platform: opts.platform || detectPlatform(),
        ClientApp: opts.clientApp || CLIENT_APP,
        AppVersion: opts.appVersion || null,
      })
      .catch(() => {}); // 전송 실패는 무시
  } catch (e) {
    // 어떤 경우에도 호출측을 깨지 않는다
  }
}
